import React from "react";
import { Provider } from "react-redux";
import { store } from "./Stores/store";
import AppGoogle from "./AppGoogle";

function App() {
  return (
    <Provider store={store}>
      <AppGoogle />
    </Provider>
  );
}

export default App;
